import { TableCell, TableSortLabel } from '@material-ui/core';
import React from 'react';

const OrderedTableHead = ({bookStore, fieldId, label, startLoading, endLoading}) => (
  <TableCell>
    <TableSortLabel
      active={ bookStore.order.order === fieldId }
      direction={ bookStore.order.sort ?? 'asc' }
      onClick={async () => {
        startLoading();
        await bookStore.setOrder(fieldId, bookStore.order.sort === 'asc' ? 'desc' : 'asc');
        endLoading();
      }}
    >
      {label}
    </TableSortLabel>
  </TableCell>
);

export default OrderedTableHead;
